var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcChat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icChat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Congratulaion-Favourite",
    transform: "translate(-107.000000, -490.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Send-Message-Copy",
    transform: "translate(64.000000, 477.000000)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "icChat",
    x: 43.5,
    y: 13,
    width: 20,
    height: 19.5,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAnCAYAAAB9qAq4AAAABGdBTUEAALGOGCHvlwAAAi5JREFUWAnNmDsvBFEYhneErUkULiFCRyQ0EgoV8QdUEp0OpX9A6V/YEFEoFIQoVlyiFBHFirhF3EJEIVas552Yzbjt7M6e3Tlf8u45c+ac73v23ObMOLEQlslkGmnW/6U20lqfyMbufTohn5Qcx7kiLY0JCk2jExTW1FY+9AfNGM660AJKI1MmX/LZFZqSxnE0g0yC4e6bybdixAsCpUEnOkTlMsXqzAuSit3ooVxkvjiK2Z0TUhVQFHAe5y9IxyOmRg35I1TnlUWUXhO3gy3pUfErfBCz5KOGE049Eotrbg/SewNcrX+V2ZIM0osbXg9O2ULl43CZHHqvgcIL5MH66kSa/SB6k6BGkG1w6hmXTT+9urLUegXYZCmcsNwhbrYYsFmL5A3AKkshXzXEz5bCCetSgDr92mrnAjywlQ6uUwHuWwy4rEWil56UhZB3MDVU8EDWW9eOhYAJ2N6908wQgKsWQd7C0g7gg+ZgjMwaiU2Ak4ITW9aYi3XoFkVtiSzUzwxkPeg5QsIlYlf+5Pp2TYU+dBEB5GIgnEdKxWo0VybIF+JMoOwLnMcRmNJoGJVyyDfx3xoIkqsCDnaRSdPnjnmU10E594TMRV7YPT0VtlASLbGF5P0ZziTgNsH3UBrphKR9TGkKoGPS0hhDETTE4Se5CeQAwHXut5iIE9rHP4BPlI+Fdmqy4R+AK5SZ+4RbLKwPUJ/GRov1V2j7fFbxGU61LYyzGm8KDVBs/U9RGCePfk5jRwAAAABJRU5ErkJggg=="
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChat);
export default __webpack_public_path__ + "static/media/icChat.dd2c814b247c22e2bb9007fc6e737de5.svg";
export { ForwardRef as ReactComponent };